import { createSelector } from 'reselect';
import { getEntities } from '../../global-selectors';

export const selectBinding = createSelector(
  getEntities,
  (entities) => entities?.binding || null,
)

export const selectBoundSubscriberUser = createSelector(
  getEntities,
  (entities) => entities.boundSubscriberUser ?? null,
)

export const selectSubscriptionActionConfigs = createSelector(
  getEntities,
  (entities) => entities.subscriptionActionConfigs ?? {},
)

export const selectInitiateBindingSecuredUrl = createSelector(
  getEntities,
  (entities) => entities?.initiateBindingSecuredUrl || null,
)
